<script lang="ts">
export default {
  name: "FlightList",
};
</script>
<script setup lang="ts">
import LeftList from "./components/left-list.vue"
import { useVueCesium } from 'vue-cesium'
import type { VcViewerProvider, VcReadyObject } from 'vue-cesium/es/utils/types'
import { flyToCamera } from 'vue-cesium/es/utils/cesium-helpers'

const $vc: VcViewerProvider = useVueCesium()

onMounted(() => {
  // $vc.creatingPromise.then((readyObj: VcReadyObject) => {
  //    flyToCamera(
  //     $vc.viewer,
  //     {
  //       position: Cesium.Cartesian3.fromDegrees(119.840, 31.010, 1000),
  //       heading: 6.283185307179586,
  //       pitch: -0.5001412827126326,
  //       roll: 6.283185307179586
  //     },
  //   )
  // })
})
</script>

<template>
  <div class="monitor-page pointer-page">
    <left-list />
  </div>
</template>

<style scoped lang="scss">
.monitor-page{
  position: relative;
  // z-index: 1;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  pointer-events: none;
}
</style>
